import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { get, hasAvatar } from 'helpers/HelperFunctions';

import Button from 'react-bootstrap/lib/Button';

import ImageCropper from 'components/ImageCropper2/ImageCropper2';
import Loader from 'components/Loader/Loader';
import SingleLocationDropdown from 'components/SingleLocationDropdown/SingleLocationDropdown';
import Modal from 'components/Modal/Modal';
import Panel from 'components/Panel/Panel';

import SvgIcon from 'components/SvgIcon/SvgIcon';

import SectorsSelector from 'components/Shared/Selectors/SectorsSelector';
import styles from './BuyerOnboarding.module.scss';

class BuyerOnboarding extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    noOfInvites: PropTypes.number,
    browseURL: PropTypes.string,
    onUpdateUser: PropTypes.func,
    updating: PropTypes.array,
    user: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      displayname:
        props.user.displayname === props.user.username
          ? ''
          : props.user.displayname,
      expanded: false,
      location: {},
      sectors: get(props.user, ['sectors'], []),
      showCompanyNameModal: false,
      showCompanyLogoModal: false,
      showCompanyLocationModal: false,
      showCompanySectorModal: false,
    };
  }

  render() {
    const { loading, noOfInvites, browseURL, updating, user } = this.props;

    const {
      displayname,
      expanded,
      location,
      sectors,
      showCompanyNameModal,
      showCompanyLocationModal,
      showCompanyLogoModal,
      showCompanySectorModal,
    } = this.state;

    const requiredInvites = 5;

    let onboardingStepsCompleted = 10;
    const totalSteps = 60;

    if (user.displayname !== user.username) {
      onboardingStepsCompleted += 10;
    }

    if (hasAvatar(user)) {
      onboardingStepsCompleted += 10;
    }

    if (user.location.method !== 'geoip') {
      onboardingStepsCompleted += 10;
    }

    if (noOfInvites >= requiredInvites) {
      onboardingStepsCompleted += 10;
    } else {
      onboardingStepsCompleted += noOfInvites;
    }

    if (!user.organisation || get(user, ['sectors'], []).length > 0) {
      onboardingStepsCompleted += 10;
    }

    const finishedOnboarding = totalSteps === onboardingStepsCompleted;
    const pcComplete = (onboardingStepsCompleted / totalSteps) * 100;

    return (
      <Panel
        className={`${styles.container} box-shadow ${
          finishedOnboarding || loading ? styles.collapse : ''
        }`}
      >
        <SvgIcon
          className={`${styles.chevron} ${expanded ? styles.up : ''}`}
          icon="chevron-down"
          size="18"
        />
        <div className={styles.progressBar}>
          <div
            className={styles.progressBarInner}
            style={{ width: `${pcComplete}%` }}
          />
        </div>
        <h2
          onClick={() => this.setState({ expanded: !expanded })}
          style={{ textTransform: 'none' }}
        >
          Next steps
        </h2>
        <div className={`${styles.list} ${expanded ? styles.expanded : ''}`}>
          <a
            className={`${styles.action} ${
              user.displayname !== user.username ? styles.completed : ''
            }`}
            onClick={() => this.setState({ showCompanyNameModal: true })}
          >
            {user.organisation ? 'Add your company name' : 'Add your name'}
            {user.displayname !== user.username &&
              !updating.includes('display_name') && (
                <SvgIcon icon="tick" size="18" />
              )}
            {updating.includes('display_name') && (
              <Loader className={styles.loader} loading />
            )}
          </a>
          <a
            className={`${styles.action} ${
              hasAvatar(user) ? styles.completed : ''
            }`}
            onClick={() => this.setState({ showCompanyLogoModal: true })}
          >
            {user.organisation ? 'Add your company logo' : 'Add your avatar'}
            {hasAvatar(user) && !updating.includes('avatar') && (
              <SvgIcon icon="tick" size="18" />
            )}
            {updating.includes('avatar') && (
              <Loader className={styles.loader} loading />
            )}
          </a>
          <a
            className={`${styles.action} ${
              user.location.method !== 'geoip' ? styles.completed : ''
            }`}
            onClick={() => this.setState({ showCompanyLocationModal: true })}
          >
            {user.organisation
              ? 'Add your company location'
              : 'Add your location'}
            {user.location.method !== 'geoip' &&
              !updating.includes('location') && (
                <SvgIcon icon="tick" size="18" />
              )}
            {updating.includes('location') && (
              <Loader className={styles.loader} loading />
            )}
          </a>
          {user.organisation && (
            <a
              className={`${styles.action} ${
                get(user, ['sectors'], []).length > 0 ? styles.completed : ''
              }`}
              onClick={() => this.setState({ showCompanySectorModal: true })}
            >
              {'Add your company sector'}
              {get(user, ['sectors'], []).length > 0 &&
                !updating.includes('sector') && (
                  <SvgIcon icon="tick" size="18" />
                )}
              {updating.includes('sector') && (
                <Loader className={styles.loader} loading />
              )}
            </a>
          )}
          <Link
            to={browseURL}
            className={`${styles.action} ${
              noOfInvites >= requiredInvites ? styles.completed : ''
            }`}
          >
            Invite{' '}
            {noOfInvites >= requiredInvites
              ? 'freelancers'
              : `${requiredInvites - noOfInvites} more freelancer${
                  requiredInvites - noOfInvites === 1 ? '' : 's'
                }`}
            {noOfInvites >= requiredInvites && (
              <SvgIcon icon="tick" size="18" />
            )}
          </Link>
        </div>

        <Modal
          backgroundExit={false}
          className={styles.nameInput}
          closeButton
          show={showCompanyNameModal}
          title={user.organisation ? 'Company name' : 'Display name'}
          onExit={() => this.setState({ showCompanyNameModal: false })}
        >
          <input
            className="form-control"
            maxLength="40"
            onChange={(event) =>
              this.setState({ displayname: event.target.value })
            }
            placeholder={`Enter ${
              user.organisation ? "your company's" : 'a display'
            } name`}
            type="text"
            value={displayname}
          />
          <Button
            bsStyle="success"
            onClick={() => {
              this.setState({ showCompanyNameModal: false });
              this.props.onUpdateUser({ displayname }, null, 'display_name');
            }}
          >
            Save
          </Button>
        </Modal>

        <Modal
          backgroundExit={false}
          closeButton
          show={showCompanyLogoModal}
          title={user.organisation ? 'Company logo' : 'Upload avatar'}
          modalStyle={{ maxWidth: '480px' }}
          onExit={() => this.setState({ showCompanyLogoModal: false })}
        >
          <ImageCropper
            existingImage={user.avatars}
            onDone={(details) => {
              this.setState({ showCompanyLogoModal: false });
              this.props.onUpdateUser(
                {
                  avatar: details.image,
                  crop: {
                    avatar: {
                      x: details.x,
                      y: details.y,
                      w: details.width,
                      h: details.height,
                    },
                  },
                },
                details.croppedImage,
                'avatar'
              );
            }}
          />
        </Modal>

        <Modal
          backgroundExit={false}
          className={`${styles.nameInput} ${styles.locationModal}`}
          closeButton
          show={showCompanyLocationModal}
          title={user.organisation ? 'Company location' : 'Your location'}
          onExit={() => this.setState({ showCompanyLocationModal: false })}
        >
          <SingleLocationDropdown
            defaultLocation={user.location.text}
            placeholder="Enter a city or country"
            onLocationChange={(details) => this.setState({ location: details })}
            showResetIcon={true}
            onLocationReset={() => this.setState({ location: {} })}
            shouldResetOnBlur={true}
            className={styles.locationInput}
          />
          <Button
            bsStyle="success"
            onClick={() => {
              this.setState({ showCompanyLocationModal: false });
              this.props.onUpdateUser({ location }, null, 'location');
            }}
            className={styles.locationModalButton}
          >
            Save
          </Button>
        </Modal>

        <Modal
          backgroundExit={false}
          className={styles.nameInput}
          closeButton
          show={showCompanySectorModal}
          title="Company Sector"
          onExit={() => this.setState({ showCompanySectorModal: false })}
        >
          <SectorsSelector
            className={styles.sectorsSelector}
            existing={get(user, ['sectors'], [])}
            onSelect={(sectors) => this.setState({ sectors })}
          />
          <Button
            bsStyle="success"
            onClick={() => {
              this.setState({ showCompanySectorModal: false });
              this.props.onUpdateUser(
                { sectors: sectors.map((sector) => sector.value) },
                null,
                'sector'
              );
            }}
          >
            Save
          </Button>
        </Modal>
      </Panel>
    );
  }
}

export default BuyerOnboarding;
